import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import search from "../../assets/img/sreach---icon.svg"
import "../../assets/css/faq.css";
import { getFaq } from "../../services/apiOtherlink";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";
const Faq = () => {
  const [searchKey, setSearchKey] = useState('');
  const [faqArr, setFaqArr] = useState([]);
  useEffect(() => {
    fetchFaq(searchKey)
  }, [])
  useEffect(() => {
    fetchFaq(searchKey)
  }, [searchKey])

  const fetchFaq = async (key) => {

    const formData = {
      searchkey: key,
      offset: 0,
      limit: 25
    }
    let faq = await getFaq(formData);
    setFaqArr(faq.faq)


  }
  return (
    <div>
      <div className="hd-breadcums">
        <h3 className="main-heading">Frequently asked question</h3>
      </div>

      <div class="">
        <div class="row ">
          <div class="col-lg-4 my-2 ">
            <div class="d-flex mb-3 ">
              <div class=" search-box search-wrapper  d-flex align-items-center px-2 gap-2">
                <span className="mobil-view-class border-end-0 ">
                  <img src={search} alt="search--Logo" className="search-logo-header mob-view-class pagess" />
                </span>
                <input type="text" class=" form-control border-start-0 search-inputs search-inside-color" placeholder="Search here"
                  onChange={(e) => { setSearchKey(e.target.value) }} value={searchKey} />
              </div>
              {/* <i class="bi bi-search search-icon-top"></i>
    <input type="text" class="form-control search-input-top" placeholder="Search here"/> */}
            </div>
          </div>
        </div>


        <div class="row ">


          <div className="col-md-10  ">
            <div class="accordion" id="customAccordion">

              <div className="accordion" id="customAccordion">
                {faqArr.map((faQue, index) => (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header" id={`heading${index}`}>
                      <button
                        className="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${index}`}  // ✅ Corrected line
                        aria-expanded="false"
                        aria-controls={`collapse${index}`}
                      >
                        <div className="icon-text-wrapper">
                          <span className="custom-icon"></span>
                          <span className="custom-text">{faQue.question}</span>
                        </div>
                      </button>
                    </h2>
                    <div
                      id={`collapse${index}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading${index}`}
                      data-bs-parent="#customAccordion"
                    >
                      <div className="accordion-body">{faQue.answer}</div>
                    </div>
                  </div>
                ))}
              </div>           
            </div>
          </div>
        </div>


      </div>
    </div>
  );
};
export default Faq;